/* By Carola Kassen-Fenster, Teil 2: Anzeige und Klick auf „Zur Kasse“ (Runde 11, 20.10.2026).
   Nachbau des Sunnafrucht-Kassen-Pop-ups (16.10.2026).
   Desktop: Vorschläge nebeneinander, waagrecht scrollbar (Pfeile, Trackpad, Mausrad).
   Handy: Blatt von unten, Liste scrollt senkrecht, Versandbalken, Summe und Kassen-Knopf bleiben unten fest. */
(function () {
  'use strict';
  var BCKF = window.BCKF;
  if (!BCKF || !BCKF.fn || BCKF.ui) return;
  BCKF.ui = true;
  var F = BCKF.fn;
  var R = BCKF.R;
  var HDR = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var SEL = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
  var WIDE = window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: true };
  /* Ersatztexte, falls die Sektion keine liefert: Englisch auf /en-Seiten (layout setzt <html lang>) */
  var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var DEF = isEn
    ? { close: 'Close', prev: 'Previous suggestions', next: 'More suggestions', add: 'add to cart', remove: 'remove from cart', subtotal: 'Subtotal', tax: 'incl. VAT', error: 'That did not work. Please try again.', title: 'A perfect match', cta: 'Continue to checkout', shipPending: '{{ remaining_amount }} away from free shipping', shipDone: 'Free shipping' }
    : { close: 'Schließen', prev: 'Vorherige Vorschläge', next: 'Weitere Vorschläge', add: 'in den Warenkorb legen', remove: 'wieder aus dem Warenkorb nehmen', subtotal: 'Zwischensumme', tax: 'inkl. MwSt.', error: 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.', title: 'Passt perfekt dazu', cta: 'Weiter zur Kasse', shipPending: 'Noch {{ remaining_amount }} bis zum Gratisversand', shipDone: 'Versandkostenfrei' };
  function S(k) { var c = F.cfg() || {}; var s = c.strings || {}; return s[k] || DEF[k] || ''; }
  function sv(p, w) { return '<svg width="' + (w || 20) + '" height="' + (w || 20) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; }
  var ICON = {
    close: sv('<path d="M6 6l12 12M18 6L6 18"/>', 22),
    cart: '<svg class="bckf-i-cart" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3.5h2.6l2.4 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2l1.7-7.3H6.3"/></svg>',
    check: '<svg class="bckf-i-check" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    truck: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9.5h-11z"/><path d="M13.5 9.5h3.8l3.2 3.4V16h-7"/><circle cx="7" cy="17.6" r="1.7"/><circle cx="17.2" cy="17.6" r="1.7"/></svg>',
    arrow: sv('<path d="M5 12h14M13 6l6 6-6 6"/>', 18),
    prev: sv('<path d="M15 6l-6 6 6 6"/>'),
    next: sv('<path d="M9 6l6 6-6 6"/>')
  };

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }
  function setText(node, t) { node.textContent = t || ''; node.hidden = !t; }
  function build() {
    if (BCKF.root && document.body.contains(BCKF.root)) return BCKF.root;
    var root = el('div', 'bckf');
    root.hidden = true;
    root.innerHTML =
      '<div class="bckf__scrim" data-bckf-close></div>' +
      '<div class="bckf__dialog" role="dialog" aria-modal="true" aria-labelledby="bckf-title" tabindex="-1">' +
      '<span class="bckf__handle" aria-hidden="true"></span>' +
      '<button type="button" class="bckf__close" data-bckf-close>' + ICON.close + '</button>' +
      '<div class="bckf__head"><p class="bckf__eyebrow"></p><h2 class="bckf__title" id="bckf-title"></h2><p class="bckf__text"></p></div>' +
      '<div class="bckf__body">' +
      '<button type="button" class="bckf__nav bckf__nav--prev" data-bckf-nav="-1" hidden>' + ICON.prev + '</button>' +
      '<div class="bckf__list"></div>' +
      '<button type="button" class="bckf__nav bckf__nav--next" data-bckf-nav="1" hidden>' + ICON.next + '</button>' +
      '</div>' +
      '<div class="bckf__bottom">' +
      '<div class="bckf__ship" aria-live="polite"><p class="bckf__ship-text"></p><div class="bckf__ship-row"><div class="bckf__bar"><div class="bckf__bar-fill"></div></div>' + ICON.truck + '</div></div>' +
      '<p class="bckf__error" role="alert" hidden></p>' +
      '<div class="bckf__foot"><div class="bckf__sum"><span class="bckf__sum-label"><span class="bckf__sum-name"></span> <small class="bckf__sum-tax"></small></span><strong class="bckf__sum-value"></strong></div>' +
      '<button type="button" class="bckf__cta"><span class="bckf__cta-label"></span>' + ICON.arrow + '</button></div>' +
      '</div>' +
      '</div>';
    root.querySelector('.bckf__close').setAttribute('aria-label', S('close'));
    root.querySelector('.bckf__nav--prev').setAttribute('aria-label', S('prev'));
    root.querySelector('.bckf__nav--next').setAttribute('aria-label', S('next'));
    root.querySelector('.bckf__sum-name').textContent = S('subtotal');
    root.querySelector('.bckf__sum-tax').textContent = S('tax');
    document.body.appendChild(root);
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-bckf-close]')) { e.preventDefault(); close(false); return; }
      var nv = t.closest('[data-bckf-nav]');
      if (nv) { e.preventDefault(); slide(Number(nv.getAttribute('data-bckf-nav'))); return; }
      if (t.closest('.bckf__cta')) { e.preventDefault(); proceed(); }
    });
    var list = root.querySelector('.bckf__list');
    list.addEventListener('scroll', nav, { passive: true });
    list.addEventListener('wheel', function (e) {
      if (!WIDE.matches || !list.classList.contains('is-scroll')) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var max = list.scrollWidth - list.clientWidth;
      if ((e.deltaY > 0 && list.scrollLeft >= max - 1) || (e.deltaY < 0 && list.scrollLeft <= 0)) return;
      list.scrollLeft += e.deltaY;
      e.preventDefault();
    }, { passive: false });
    window.addEventListener('resize', nav);
    BCKF.root = root;
    return root;
  }
  function nav() {
    var root = BCKF.root;
    if (!root || root.hidden) return;
    var list = root.querySelector('.bckf__list');
    var on = WIDE.matches && list.classList.contains('is-scroll');
    var end = list.scrollWidth - list.clientWidth - 4;
    root.querySelector('.bckf__nav--prev').hidden = !on || list.scrollLeft <= 4;
    root.querySelector('.bckf__nav--next').hidden = !on || list.scrollLeft >= end;
    var m = list.querySelector('.bckf-item__media');
    if (m) root.querySelector('.bckf__body').style.setProperty('--bckf-navtop', Math.round(m.offsetHeight / 2 + 2) + 'px');
  }
  function slide(dir) {
    var list = BCKF.root.querySelector('.bckf__list');
    var card = list.querySelector('.bckf-item');
    var step = card ? Math.max(card.offsetWidth + 16, list.clientWidth - card.offsetWidth) : list.clientWidth;
    try { list.scrollBy({ left: dir * step, behavior: 'smooth' }); } catch (e) { list.scrollLeft += dir * step; }
  }
  function mark(item, btn, name, on) {
    item.classList.toggle('is-added', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', name + ' ' + (on ? S('remove') : S('add')));
  }
  function card(p) {
    var item = el('div', 'bckf-item');
    var media = el('div', 'bckf-item__media');
    if (p.img) {
      var img = document.createElement('img');
      img.src = p.img;
      img.alt = p.t;
      img.width = 400;
      img.height = 400;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    }
    var btn = el('button', 'bckf-item__add');
    btn.type = 'button';
    btn.innerHTML = ICON.cart + ICON.check;
    var body = el('div', 'bckf-item__body');
    body.appendChild(el('p', 'bckf-item__name', p.t));
    if (p.label) {
      var meta = el('div', 'bckf-item__meta');
      meta.appendChild(el('span', 'bckf-item__pill', p.label));
      body.appendChild(meta);
    }
    var price = el('div', 'bckf-item__price');
    price.appendChild(el('span', '', p.pf));
    body.appendChild(price);
    item.appendChild(media);
    item.appendChild(btn);
    item.appendChild(body);
    mark(item, btn, p.t, false);
    btn.addEventListener('click', function () { toggle(p, item, btn, p.t); });
    return item;
  }
  function err(msg) {
    var e = BCKF.root && BCKF.root.querySelector('.bckf__error');
    if (!e) return;
    e.textContent = msg || '';
    e.hidden = !msg;
  }
  /* Versandtext wie die Leiste im Warenkorb: Schwelle aus den Theme-Einstellungen mal Währungskurs, Betrag rot */
  function shipText(node, c, rest) {
    node.textContent = '';
    var parts = F.plain(c.shipPending || DEF.shipPending).split(/\{\{\s*remaining_amount\s*\}\}/);
    node.appendChild(document.createTextNode(parts[0] || ''));
    node.appendChild(el('span', 'bckf__ship-amount', F.fmt(rest)));
    node.appendChild(document.createTextNode(parts.slice(1).join('')));
  }
  function totals(c, total) {
    var root = BCKF.root;
    root.querySelector('.bckf__sum-value').textContent = F.fmt(total);
    var box = root.querySelector('.bckf__ship');
    var units = parseInt(c.shipUnits, 10);
    if (!units) { box.hidden = true; return; }
    box.hidden = false;
    var thr = Math.round(units * F.rate()) * 100;
    var rest = thr - total;
    var text = root.querySelector('.bckf__ship-text');
    var bar = root.querySelector('.bckf__bar-fill');
    if (rest > 0) {
      box.classList.remove('is-free');
      shipText(text, c, rest);
      bar.style.width = Math.max(3, Math.min(100, total / thr * 100)) + '%';
    } else {
      box.classList.add('is-free');
      text.textContent = F.plain(c.shipDone || DEF.shipDone);
      bar.style.width = '100%';
    }
  }
  function toggle(p, item, btn, name) {
    var st = BCKF.st;
    var c = F.cfg() || {};
    if (btn.disabled) return;
    var on = !!st.added[p.v];
    err('');
    if (st.preview) {
      st.total += on ? -p.p : p.p;
      if (on) delete st.added[p.v]; else st.added[p.v] = 'vorschau';
      mark(item, btn, name, !on);
      totals(c, st.total);
      return;
    }
    btn.disabled = true;
    item.classList.add('is-busy');
    var req = on
      ? { url: 'cart/change.js', data: { id: st.added[p.v], quantity: 0 } }
      : { url: 'cart/add.js', data: { items: [{ id: p.v, quantity: 1, properties: { _quelle: 'Kassen-Fenster' } }] } };
    fetch(R + req.url, { method: 'POST', headers: HDR, credentials: 'same-origin', body: JSON.stringify(req.data) })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error((j && (j.description || j.message)) || '');
          return j;
        });
      })
      .then(function (j) {
        if (on) { delete st.added[p.v]; }
        else { var line = j && j.items && j.items[0] ? j.items[0] : j; st.added[p.v] = line && line.key ? line.key : p.v; }
        st.changed = true;
        mark(item, btn, name, !on);
        return F.getCart().then(function (cart) { st.total = cart.total_price; totals(c, cart.total_price); });
      })
      .catch(function (e) { err((e && e.message) || S('error')); })
      .then(function () { btn.disabled = false; item.classList.remove('is-busy'); });
  }
  function headTexts(c, res) {
    var h = res.head || {};
    if (h.kind === 'refs') {
      var src = res.sources || [];
      var eb = src.length === 1 ? ((c.eyebrow || '') + ' ' + src[0].title).trim() : (c.eyebrowMulti || c.eyebrow || '');
      return { eyebrow: eb, title: c.title || S('title'), text: c.text };
    }
    return { eyebrow: c.fbEyebrow, title: c.fbTitle || c.title || S('title'), text: c.fbText };
  }
  function open(c, res, preview) {
    var root = build();
    clearTimeout(BCKF.hideTimer);
    BCKF.st = { changed: false, added: {}, preview: !!preview, total: res.cart.total_price, origin: preview ? null : BCKF.origin };
    var h = headTexts(c, res);
    setText(root.querySelector('.bckf__eyebrow'), h.eyebrow);
    setText(root.querySelector('.bckf__title'), h.title);
    setText(root.querySelector('.bckf__text'), h.text);
    root.querySelector('.bckf__cta-label').textContent = c.cta || S('cta');
    var list = root.querySelector('.bckf__list');
    list.innerHTML = '';
    res.items.forEach(function (p) { list.appendChild(card(p)); });
    list.classList.toggle('is-scroll', res.items.length > 3);
    list.scrollLeft = 0;
    list.scrollTop = 0;
    err('');
    totals(c, res.cart.total_price);
    root.hidden = false;
    root.getBoundingClientRect();
    root.classList.add('is-open');
    document.documentElement.classList.add('bckf-lock');
    nav();
    var dlg = root.querySelector('.bckf__dialog');
    dlg.scrollTop = 0;
    try { dlg.focus({ preventScroll: true }); } catch (e) { dlg.focus(); }
    document.addEventListener('keydown', onKey, true);
  }
  function close(silent) {
    var root = BCKF.root;
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('bckf-lock');
    document.removeEventListener('keydown', onKey, true);
    clearTimeout(BCKF.hideTimer);
    BCKF.hideTimer = setTimeout(function () { root.hidden = true; }, 260);
    if (silent) return;
    var st = BCKF.st || {};
    if (st.changed && !st.preview) { window.location.reload(); return; }
    if (st.origin && st.origin.focus) { try { st.origin.focus({ preventScroll: true }); } catch (e) {} }
  }
  function pass(t) {
    BCKF.passing = true;
    try { t.click(); } finally { setTimeout(function () { BCKF.passing = false; }, 0); }
  }
  function proceed() {
    var st = BCKF.st || {};
    close(true);
    if (st.preview) return;
    if (st.changed || !st.origin || !document.body.contains(st.origin)) { window.location.href = R + 'checkout'; return; }
    pass(st.origin);
  }
  function onKey(e) {
    if (!BCKF.root || BCKF.root.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(false); return; }
    if (e.key !== 'Tab') return;
    var f = BCKF.root.querySelectorAll('button:not([disabled]):not([hidden])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('click', function (e) {
    if (BCKF.passing) return;
    var t = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!t || (BCKF.root && BCKF.root.contains(t))) return;
    var c = F.cfg();
    if (!c || !c.enabled) return;
    if (c.once && F.seen() && !F.design()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (BCKF.busy) return;
    BCKF.busy = true;
    BCKF.origin = t;
    t.setAttribute('aria-busy', 'true');
    var done = false;
    function finish() { done = true; BCKF.busy = false; t.removeAttribute('aria-busy'); }
    var timer = setTimeout(function () { if (!done) { finish(); pass(t); } }, 4000);
    F.resolve(c).then(function (res) {
      if (done) return;
      clearTimeout(timer);
      finish();
      if (!res) { pass(t); return; }
      if (!F.design()) F.markSeen();
      open(c, res, false);
    }).catch(function () {
      if (done) return;
      clearTimeout(timer);
      finish();
      pass(t);
    });
  }, true);

  /* Vorladen: auf der Warenkorb-Seite sofort, sonst sobald der Mauszeiger oder Fokus auf einen Kassen-Knopf kommt */
  var warmed = false;
  function warm() {
    if (warmed) return;
    var c = F.cfg();
    if (!c || !c.enabled || (c.once && F.seen() && !F.design())) return;
    warmed = true;
    F.prefetch(c);
  }
  function near(e) { var t = e.target && e.target.closest ? e.target.closest(SEL) : null; if (t) warm(); }
  document.addEventListener('pointerover', near, true);
  document.addEventListener('focusin', near, true);
  function start() { var c = F.cfg(); if (c && c.template === 'cart') warm(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* Theme-Editor: Sektion auswählen zeigt das Fenster als Vorschau, ohne den Warenkorb zu ändern */
  document.addEventListener('shopify:section:select', function (e) {
    var c = F.cfg();
    if (!c || !e.detail || e.detail.sectionId !== c.section) return;
    F.resolve(c, true).then(function (res) { if (res) open(c, res, true); }).catch(function () {});
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var c = F.cfg();
    if (c && e.detail && e.detail.sectionId === c.section) close(true);
  });
})();
